import { white } from '@pelotoncycle/design-system'

type LogoProps = {
  height?: string
  width?: string
  fill?: string
}

const DEFAULTS = {
  width: '120',
  height: '36',
  fill: white,
}

const LogoAdmin = ({
  height = DEFAULTS.height,
  width = DEFAULTS.width,
  fill = DEFAULTS.fill,
}: LogoProps) => (
  <svg viewBox="0 0 120 36" width={width} height={height} fill="none">
    <path
      d="M32.251 34.829C32.251 34.919 32.323 35 32.422 35H33.421C33.511 35 33.583 34.919 33.583 34.829V29.051C33.583 28.961 33.511 28.88 33.421 28.88H32.593L31.279 29.906C31.252 29.933 31.225 30.005 31.225 30.041V30.608C31.225 30.698 31.297 30.779 31.387 30.779H32.251V34.829ZM37.2832 34.964C37.3012 35.036 37.3732 35.09 37.4452 35.09H37.5892C37.6522 35.09 37.7152 35.045 37.7422 34.991L39.3802 31.31H39.4072L41.0542 34.991C41.0812 35.045 41.1442 35.09 41.2072 35.09H41.3512C41.4232 35.09 41.4952 35.036 41.5132 34.964L43.2142 28.916C43.2502 28.79 43.1782 28.7 43.0522 28.7H41.9992C41.9272 28.7 41.8552 28.763 41.8372 28.826L41.0632 31.877H41.0272L39.6322 28.709C39.6142 28.655 39.5602 28.61 39.4792 28.61H39.3172C39.2452 28.61 39.1912 28.655 39.1642 28.709L37.7692 31.877H37.7332L36.9592 28.826C36.9412 28.763 36.8692 28.7 36.7972 28.7H35.7442C35.6182 28.7 35.5462 28.79 35.5822 28.916L37.2832 34.964ZM47.5379 35H48.5279C48.7079 35 48.8069 34.892 48.8519 34.784L49.1759 34.064H51.6239L51.9479 34.775C52.0289 34.946 52.1009 35 52.2629 35H53.2619C53.3969 35 53.4689 34.883 53.4149 34.766L50.5979 28.709C50.5709 28.655 50.5079 28.61 50.4449 28.61H50.3549C50.2919 28.61 50.2289 28.655 50.2019 28.709L47.3849 34.766C47.3309 34.883 47.4029 35 47.5379 35ZM49.7159 32.84L50.3909 31.355H50.3999L51.0839 32.84H49.7159ZM55.1539 34.829C55.1539 34.919 55.2259 35 55.3159 35H57.5119C59.2489 35 60.6709 33.587 60.6709 31.841C60.6709 30.113 59.2489 28.7 57.5119 28.7H55.3159C55.2259 28.7 55.1539 28.781 55.1539 28.871V34.829ZM56.5579 33.668V30.023H57.4219C58.4389 30.023 59.1769 30.824 59.1769 31.841C59.1769 32.867 58.4389 33.668 57.4219 33.668H56.5579ZM62.376 34.802C62.358 34.919 62.439 35 62.547 35H63.609C63.699 35 63.771 34.928 63.78 34.856L64.176 32.075H64.194L65.715 34.991C65.742 35.045 65.814 35.09 65.868 35.09H66.03C66.075 35.09 66.156 35.045 66.183 34.991L67.695 32.075H67.713L68.118 34.856C68.127 34.928 68.208 35 68.289 35H69.351C69.459 35 69.54 34.919 69.522 34.802L68.505 28.754C68.496 28.673 68.415 28.61 68.343 28.61H68.199C68.154 28.61 68.073 28.646 68.046 28.7L65.958 32.588H65.94L63.852 28.7C63.825 28.646 63.744 28.61 63.699 28.61H63.555C63.483 28.61 63.402 28.673 63.393 28.754L62.376 34.802ZM71.6734 34.829C71.6734 34.919 71.7544 35 71.8444 35H72.9244C73.0144 35 73.0954 34.919 73.0954 34.829V28.871C73.0954 28.781 73.0144 28.7 72.9244 28.7H71.8444C71.7544 28.7 71.6734 28.781 71.6734 28.871V34.829ZM75.6441 34.829C75.6441 34.919 75.7251 35 75.8151 35H76.8861C76.9851 35 77.0571 34.919 77.0571 34.829V31.472H77.0661L80.6211 35.045C80.6391 35.063 80.7111 35.09 80.7381 35.09H80.8821C80.9721 35.09 81.0531 35.018 81.0531 34.928V28.871C81.0531 28.781 80.9721 28.7 80.8821 28.7H79.8021C79.7031 28.7 79.6311 28.781 79.6311 28.871V32.066H79.6221L76.0311 28.61H75.8061C75.7161 28.61 75.6351 28.682 75.6351 28.772L75.6441 34.829Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.342 17.3952C37.548 17.3952 38.316 16.8575 38.316 15.5542C38.316 14.2347 37.5127 13.7322 36.342 13.7322H34.6815V17.3952H36.342ZM32.2361 11.5947H36.4118C38.8404 11.5947 40.8326 12.7928 40.8326 15.5543C40.8326 18.3163 38.823 19.5327 36.4118 19.5327H34.6815V23.4065H32.2361V11.5947Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.4253 11.5947H52.2873V13.7323H46.8708V16.4406H51.6413V18.5245H46.8708V21.2697H52.5328V23.4065H44.4253V11.5947Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.6489 11.5947H59.095V21.2697H64.477V23.4065H56.6489V11.5947Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.9928 17.4993C76.9928 15.2941 75.5251 13.6089 73.3589 13.6089C71.1914 13.6089 69.7244 15.2941 69.7244 17.4993C69.7244 19.7055 71.1914 21.3908 73.3589 21.3908C75.5251 21.3908 76.9928 19.7055 76.9928 17.4993ZM67.2085 17.4992C67.2085 14.0089 69.9341 11.4375 73.359 11.4375C76.7832 11.4375 79.5081 14.0089 79.5081 17.4992C79.5081 20.9906 76.7832 23.5617 73.359 23.5617C69.9341 23.5617 67.2085 20.9906 67.2085 17.4992Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.5337 13.7323H82.1443V11.5947H91.3699V13.7323H87.9805V23.4065H85.5337V13.7323Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.775 17.4993C103.775 15.2941 102.307 13.6089 100.141 13.6089C97.9732 13.6089 96.5054 15.2941 96.5054 17.4993C96.5054 19.7055 97.9732 21.3908 100.141 21.3908C102.307 21.3908 103.775 19.7055 103.775 17.4993ZM93.9893 17.4992C93.9893 14.0089 96.7153 11.4375 100.14 11.4375C103.565 11.4375 106.29 14.0089 106.29 17.4992C106.29 20.9906 103.565 23.5617 100.14 23.5617C96.7153 23.5617 93.9893 20.9906 93.9893 17.4992Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.763 17.9165C113.169 17.3608 112.347 16.3011 112.347 16.3011C112.347 16.3011 112.523 17.6038 112.523 18.4547V23.4062H110.234V11.4897H110.478L116.471 17.084C117.048 17.6217 117.868 18.6976 117.868 18.6976C117.868 18.6976 117.712 17.3608 117.712 16.5451V11.5944H120V23.5097H119.757L113.763 17.9165Z"
      fill={fill}
    />
    <mask
      id="mask0_367_1264"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="120"
      height="35"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0 35H120V0H0" fill="#fff" />
    </mask>
    <g mask="url(#mask0_367_1264)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8079 8.4105L23.3551 4.02306C24.1006 2.74073 23.6579 1.10051 22.3677 0.359343C21.0779 -0.380524 19.427 0.0585508 18.6821 1.34175L16.1344 5.72803C10.7058 4.02681 4.62866 6.22767 1.6647 11.3306C-0.216396 14.5689 -0.451841 18.3032 0.698966 21.5761L5.40307 13.477C5.40307 13.4767 5.40307 13.4767 5.40307 13.4764C6.48406 11.6155 8.22958 10.2842 10.3175 9.72758C12.4065 9.17127 14.5878 9.45707 16.4604 10.5318C20.3257 12.7502 21.6543 17.6807 19.4231 21.5223C17.191 25.365 12.2311 26.686 8.36617 24.4678L11.0639 19.822C12.3545 20.5632 14.0044 20.1232 14.7497 18.8409C15.4943 17.558 15.0523 15.9185 13.762 15.1773C12.4715 14.4366 10.8214 14.8762 10.076 16.1587L1.47033 30.9767C0.725529 32.2594 1.16739 33.8992 2.45784 34.6399C3.74828 35.3811 5.39901 34.9412 6.14338 33.6581L8.69176 29.272C14.1201 30.9729 20.1973 28.7718 23.1615 23.668C26.1257 18.5656 25.0045 12.2328 20.8079 8.4105Z"
        fill={fill}
      />
    </g>
  </svg>
)

export { LogoAdmin }
